import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth'
import {
  fetchPostPurchaseBrandConnectAnalytics,
  fetchPostPurchaseBrandConnectAnalyticsError,
  fetchPostPurchaseBrandConnectAnalyticsSuccess,
  IPostPurchaseBrandConnectAnalytics,
  PostPurchaseBrandConnectActionTypes,
} from '@store/postPurchaseAnalytics'
import { selectSubmissionPerformanceLink } from '@store/submissions'
import { networkRequest } from '@utils'
import { WatcherFunction } from '..'

type IPostPurchaseBrandConnectResponse = IPostPurchaseBrandConnectAnalytics[]

export function* handleFetchPostPurchaseBrandConnectAnalytics(
  action: ReturnType<typeof fetchPostPurchaseBrandConnectAnalytics>,
) {
  const submissionId = action.payload

  try {
    const authToken: string = yield select(selectAuthToken)
    const submissionPerformanceLink: IHateoasLink = yield select(
      selectSubmissionPerformanceLink,
      submissionId,
    )

    const response: IPostPurchaseBrandConnectResponse = yield call(
      networkRequest,
      submissionPerformanceLink.method,
      submissionPerformanceLink.href,
      undefined,
      authToken,
    )

    // Backend now returns flattened array directly
    if (Array.isArray(response)) {
      yield put(fetchPostPurchaseBrandConnectAnalyticsSuccess(submissionId, response))
    } else {
      throw new Error('Invalid BrandConnect response: expected array')
    }
  } catch (error) {
    yield put(fetchPostPurchaseBrandConnectAnalyticsError(error))
  }
}

function* watchFetchPostPurchaseBrandConnectAnalytics() {
  yield takeLatest(
    PostPurchaseBrandConnectActionTypes.FETCH_REQUEST,
    handleFetchPostPurchaseBrandConnectAnalytics,
  )
}

export const postPurchaseBrandConnectAnalyticsSagas: ReadonlyArray<WatcherFunction> = [
  watchFetchPostPurchaseBrandConnectAnalytics,
]
